<template>
  <coming-soon v-if="collection.status === 'coming_soon'" />
  <premint-sale v-if="collection.status === 'premint_sale'" :collection="collection" />
  <pre-sale v-if="showPreSale" :collection="collection" />
  <open-sale v-if="collection.status === 'open_sale'" :collection="collection" />
  <fiat-sale v-if="collection.status === 'fiat_sale'" :collection="collection" />
  <post-sale v-if="collection.status === 'post_sale'" :collection="collection" />
</template>

<script>
import ComingSoon from './ComingSoon.vue'
import PremintSale from './PremintSale.vue'
import PreSale from './PreSale.vue'
import OpenSale from './OpenSale.vue'
import FiatSale from './FiatSale.vue'
import PostSale from './PostSale.vue'
import { isAllowListActive } from '@/dropHelpers'
import { mapState } from 'vuex'

export default {
  components: {
    ComingSoon,
    PremintSale,
    PreSale,
    OpenSale,
    PostSale,
    FiatSale
  },
  props: ['collection'],
  computed: {
    ...mapState({
      collectionReady: function(state) {
        return state.ui.dataLoaded
      }
    }),
    showPreSale() {
      return isAllowListActive(this.collection)
    }
  }
}
</script>